import React from "react";
import TableText from "@/components/table/TableText";
import moment from "moment";
import { numConvert, calculation } from "@/method";
import getJson from "../../../../../method";

export default (data, date, data4_1) => {

    const totalName = ['inventory', 'ava', 'sold', 'rev'];
    const totalIndex = [20, 41, 62];
    totalIndex.forEach(index => {
        totalName.forEach(name => {
            data[index][name] = data.reduce((a, b, i) => {
                if (i < index && i >= (index - 20)) a += numConvert(b[name]);
                return a
            }, 0).toFixed(2);
        });
    });

    // 计算总汇总
    totalName.forEach(name => {
        data[63][name] = totalIndex.reduce((a, b) => a += numConvert(data[b][name]), 0).toFixed(2);
        data[67][name] = [65, 66].reduce((a, b) => a += numConvert(data[b][name]), 0).toFixed(2);
    });

    const index = (moment(date).format('M') - 1) * 3 + 1;
    data[64].ava = getJson([index, 'grand_rms'], data4_1);
    data[64].rev = getJson([index, 'grand_rev'], data4_1);
    data[64].sold = getJson([index, 'grand_rn'], data4_1);

    data.forEach((item, index) => {
        data[index].occ = calculation(item.sold, item.ava, 4);
        data[index].adr = calculation(item.rev, item.sold);
        if (![64, 67].includes(index)) data[index].revp = calculation(item.rev, data[63].rev, 4);
    });

    return data
}

const totalIndex = [20, 41, 62, 63, 64, 67];
export const columns = (onChange, date, print) => {
    return [
        {
            title: `Room Type Name`,
            dataIndex: 'name',
            key: 'name',
            align: "center",
            width: 200,
            render: (text, record, index) => {
                const title = ['Room Type Name'];
                const props = {
                    text,
                    index,
                    type: moment(date).format('M') == 1 && !totalIndex.includes(index) && !print ? 'input' : 'text',
                    name: "name",
                    onChange,
                    totalIndex,
                };

                return (
                    <TableText data={props} />
                )
            }
        },
        {
            title: `Inventory`,
            dataIndex: 'inventory',
            key: 'inventory',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const title = ['Inventory'];
                const props = {
                    text,
                    index,
                    type: !totalIndex.includes(index) && !print ? 'inputNumber' : 'number',
                    name: "inventory",
                    onChange,
                    totalIndex,
                };
                if (index > 62 || index == 20 || index == 41) {
                    props.compared = {
                        title,
                        record,
                        sqlName: "_4_1_4_new"
                    }
                }

                return (
                    <TableText data={props} />
                )
            }
        },
        {
            title: `Available Rooms`,
            dataIndex: 'ava',
            key: 'ava',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const title = ['Available Rooms'];
                const props = {
                    text,
                    index,
                    type: !totalIndex.includes(index) && !print ? 'inputNumber' : 'number',
                    name: "ava",
                    onChange,
                    totalIndex,
                };
                if (index > 62 || index == 20 || index == 41) {
                    props.compared = {
                        title,
                        record,
                        sqlName: "_4_1_4_new"
                    }
                }

                return (
                    <TableText data={props} />
                )
            }
        },
        {
            title: `Sold Room`,
            dataIndex: 'sold',
            key: 'sold',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const title = ['Sold Room'];
                const props = {
                    text,
                    index,
                    type: !totalIndex.includes(index) && !print ? 'inputNumber' : 'number',
                    name: "sold",
                    onChange,
                    totalIndex,
                };
                if (index > 62 || index == 20 || index == 41) {
                    props.compared = {
                        title,
                        record,
                        sqlName: "_4_1_4_new"
                    }
                }

                return (
                    <TableText data={props} />
                )
            }
        },
        {
            title: `Occ%`,
            dataIndex: 'occ',
            key: 'occ',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const title = ['Occ%'];
                const props = {
                    text,
                    index,
                    type: 'percent',
                    name: "occ",
                    onChange,
                    totalIndex,
                };
                if (index > 62 || index == 20 || index == 41) {
                    props.compared = {
                        title,
                        record,
                        sqlName: "_4_1_4_new"
                    }
                }

                return (
                    <TableText data={props} />
                )
            }
        },
        {
            title: `ADR`,
            dataIndex: 'adr',
            key: 'adr',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const title = ['ADR'];
                const props = {
                    text,
                    index,
                    type: 'number',
                    name: "adr",
                    onChange,
                    totalIndex,
                };
                if (index > 62 || index == 20 || index == 41) {
                    props.compared = {
                        title,
                        record,
                        sqlName: "_4_1_4_new"
                    }
                }

                return (
                    <TableText data={props} />
                )
            }
        },
        {
            title: `Room Revenue`,
            dataIndex: 'rev',
            key: 'rev',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const title = ['Room Revenue'];
                const props = {
                    text,
                    index,
                    type: !totalIndex.includes(index) && !print ? 'inputNumber' : 'number',
                    name: "rev",
                    onChange,
                    totalIndex,
                };
                if (index > 62 || index == 20 || index == 41) {
                    props.compared = {
                        title,
                        record,
                        sqlName: "_4_1_4_new"
                    }
                }

                return (
                    <TableText data={props} />
                )
            }
        },
        {
            title: `Room Revenue %`,
            dataIndex: 'revp',
            key: 'revp',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const title = ['Room Revenue %'];
                const props = {
                    text,
                    index,
                    type: 'percent',
                    name: "revp",
                    onChange,
                    totalIndex,
                };
                if (index > 62 || index == 20 || index == 41) {
                    props.compared = {
                        title,
                        record,
                        sqlName: "_4_1_4_new"
                    }
                }

                return (
                    <TableText data={props} />
                )
            }
        }
    ]
}


// WEBPACK FOOTER //
// ./src/components/table/4.0/4-1/4-1-4/compute.js